import { types } from 'mobx-state-tree'

const model = types
  .model('HierarchyState', {
    expanded: types.boolean,
    visible: types.boolean,
  })

export default model
